import React from 'react';

export const Image = React.memo(function Image({ classer, src, alter }) {
  return <img alt={alter} src={src} className={classer} />;
});
